import { render, staticRenderFns } from "./AddCheck.vue?vue&type=template&id=5afdc348&scoped=true"
import script from "./AddCheck.vue?vue&type=script&lang=js"
export * from "./AddCheck.vue?vue&type=script&lang=js"
import style0 from "./AddCheck.vue?vue&type=style&index=0&id=5afdc348&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afdc348",
  null
  
)

export default component.exports